<template>
  <div class="foot">
    <div class="w content flex">
      <div class="con_l">
        <div class="con_">
          <div class="tit">网站介绍</div>
          <div class="con">{{ findBottomBar.introduction }}</div>
        </div>
        <div class="con_">
          <div class="tit">联系方式</div>
          <div class="con">
            <div v-for="(item, idx) in findBottomBar.contact" :key="idx">
              {{ item.type }}：{{ item.content }}
            </div>
          </div>
        </div>
        <div class="footer">{{ findBottomBar.endInfo }}</div>

      </div>
      <div class="con_r">
        <div>
          <img class="school_logo" :src="imgPrefix + findBottomBar.pic" alt="" />
        </div>
        <div class="qrcode_box flex">
          <div class="qrcode" v-for="item in findBottomBar.qrCodes" :key="item.codeId">
            <img :src="imgPrefix + item.codeId" alt="">
            <div>{{ item.codeName }}</div>
          </div>
        </div>
        <!-- <div>
          <div class="tit">官方微博</div>
          <img src="../assets/index/weibo-qrcode.png" alt="" />
        </div>
        <div>
          <div class="tit">官方微信</div>
          <img src="../assets/index/weixin-qrcode.png" alt="" />
        </div>
        <div>
          <div class="tit">移动校园</div>
          <img src="../assets/index/qrcode.png" alt="" />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import imgPrefix from "../../utils/imgPrefix";
import {findBottomBarApi} from '../api/index'
export default {
  data() {
    return {
      findBottomBar: {
        introduction: "",
        contact: [],
        pic: "",
        endInfo: "",
      },
      imgPrefix,
    };
  },
  created() {
    // 获取底部信息
    findBottomBarApi()
      .then((res) => {
        console.log(res,'----------');
        
        sessionStorage.setItem("findBottomBar", JSON.stringify(res));
        this.findBottomBar = res;
      })
      .catch((err) => {
        this.$message.error(err.message);
        sessionStorage.setItem("findBottomBar", JSON.stringify({}));
      });
    // this.findBottomBar = JSON.parse(sessionStorage.getItem("findBottomBar"));
  },
};
</script>

<style lang="less" scoped>
.foot {
  /* height: 302px; */
  background: #f7f8fb;
  padding: 32px 0 34px 0;
  margin-top: 90px;
  .content {
    justify-content: space-between;
    .tit {
      font-size: 16px;
      color: #1f2c4b;
      padding-bottom: 12px;
    }
    .con_l {
      width: 60%;
      margin-right: 20px;
      // justify-content: space-between;
      // align-items: normal;
      .con_{
        margin-bottom: 24px;
      }
      div {
        flex: 1;
        width: 100%;
        text-align: left;
      }
      .con {
        font-size: 14px;
        color: #7a8ba4;
        line-height: 20px;
      }
    }
    .con_l div:first-child {
      margin-right: 4%;
    }
    .con_r {
      width: 35%;
      align-items: normal;
      .school_logo{
        // width: 100%;
        height: 52px;
      }
      .qrcode_box{
        margin-top: 42px;
        justify-content: space-between;
        .qrcode{
          img{
            width: 96px;
            height: 96px;
            margin-bottom: 12px;
          }
          div{
            color: #7A8BA4;
          }
        }
      }
    }
  }
  .footer {
    font-size: 14px;
    text-align: left;
    padding-top: 24px;
  }
}
</style>
